import { query } from 'api/prismic'
import { GetServerSideProps } from 'next'
import { layoutQuery } from 'prismic/fragments/layoutQuery'
import { linkResolver } from 'prismic/linkResolver'
import { pageQuery } from 'prismic/queries/pageQuery'
import { Layout, Page } from 'prismic-types'

import PageComponent, { PageProps } from 'pages/[...uid]'
import { localeToPrismicLocale } from 'utils/i18n'
import {
  singleNavigationQuery,
  topNavigationQuery,
} from 'prismic/fragments/navigationQuery'

export default PageComponent

export const getServerSideProps: GetServerSideProps<PageProps> = async ({
  preview = false,
  previewData,
  resolvedUrl,
  locale,
}) => {
  const lang = localeToPrismicLocale(locale)
  const uid = 'stud'
  const variables = { uid, lang }
  const cacheKey = `${lang}-uid-${uid}`

  // GraphQL hack for deep navigation
  const topNavData = await query(topNavigationQuery, { variables: { lang } })
  const topNav =
    topNavData?.allNavigations.edges
      ?.filter((edge) => edge && edge.node)
      .map((edge) => {
        return edge?.node._meta.uid
      }) ?? []

  const megamenuItems = async () => {
    return await Promise.all(
      topNav.map((uid) =>
        query(singleNavigationQuery, { variables: { lang, uid: uid! } })
      )
    )
  }

  const [navData, layoutData, pageData] = await Promise.all([
    megamenuItems(),
    query(layoutQuery, {
      variables: { lang },
      cacheKey: `layout-${lang}`,
    }),
    query(pageQuery, {
      previewData,
      variables,
      cacheKey: `page-${cacheKey}`,
      breadcrumbs: [resolvedUrl],
    }),
  ])

  const layout: Layout | null = layoutData?.layout ?? null
  const page: Page | null = pageData?.page ?? null
  const onboardingButtonLink = page?.onboarding_button_link ?? null
  const parentLink = page?.parent ? linkResolver(page.parent) : null
  const navigation = navData.map((navDataItem) => navDataItem?.navigation)

  if (
    !page ||
    (parentLink && parentLink !== '/' && !resolvedUrl.includes(parentLink))
  ) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      preview,
      page,
      navigation,
      layout,
      onboardingButtonLink,
    },
  }
}
